import { render, staticRenderFns } from "./ORCDiscern.vue?vue&type=template&id=32a70030&scoped=true"
import script from "./ORCDiscern.vue?vue&type=script&lang=js"
export * from "./ORCDiscern.vue?vue&type=script&lang=js"
import style0 from "./ORCDiscern.vue?vue&type=style&index=0&id=32a70030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a70030",
  null
  
)

export default component.exports